import { useMemo, useCallback } from 'react';
import utils from '@happylife-a/utils';
import { useAppConfigs } from '../contexts/AppConfigsContext';

function useIncreasedPrices({ productDetail } = {}) {
  const { productPriceIncreasePercent } = useAppConfigs();

  const hasIncreasePercent = !!productPriceIncreasePercent && productPriceIncreasePercent > 0;

  const increase = useCallback(
    (value) => {
      if (!value) {
        return null;
      }

      return utils.helpers.currency.increasePrice(value, productPriceIncreasePercent);
    },
    [productPriceIncreasePercent]
  );

  const increaseAndBeautify = useCallback(
    (value) => {
      if (!value) {
        return null;
      }

      return utils.helpers.currency.beautify(increase(value));
    },
    [increase]
  );

  return useMemo(
    () => ({
      increase: increase,
      increaseAndBeautify: increaseAndBeautify,
      hasIncreasePercent: hasIncreasePercent,
      discountedPrice: increaseAndBeautify(productDetail?.discountedPrice),
      price: increaseAndBeautify(productDetail?.price),
      discountedPriceAmount: increase(productDetail?.discountedPrice),
      priceAmount: increase(productDetail?.price),
    }),
    [productDetail, increase]
  );
}

export default useIncreasedPrices;
